import { render, staticRenderFns } from "./UserPointsList.vue?vue&type=template&id=299fb1ea&scoped=true&"
import script from "./UserPointsList.vue?vue&type=script&lang=js&"
export * from "./UserPointsList.vue?vue&type=script&lang=js&"
import style0 from "./UserPointsList.vue?vue&type=style&index=0&id=299fb1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299fb1ea",
  null
  
)

export default component.exports